import ErrorIndicator from "../../Components/ErrorIndicator";
import List from "../../Components/List";
import LoadingIndicator from "../../Components/LoadingIndicator";
import { getRegionFounderDetailsAsync } from "../../services/adminService";
import { getInvoicesData } from "../../services/serviceProvider";
import { useAsync } from "../../utilities/customHooks";

const Invoices = () => {
    
  const invoicesAsync = useAsync(() => getInvoicesData(), []);

  if (invoicesAsync.status === "pending") {
    return <LoadingIndicator />;
  }
  
  if (invoicesAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const invoices = invoicesAsync.value.invoiceReadyArray

  const columnHeaderData = [
    {
      header: "Company",
      key: "company"
    },
    {
      header: "Email",
      key: "email"
    },
    {
      header: "Tier",
      key: "tier"
    },
  ]

  return (
    <div className="resourcesCont !pt-0">
      <div className="flex flex-col w-full">
        <h2 className="mb-4">Statements of Work Available for Invoice</h2>
        <List 
          contentArray={invoices}
          columnHeaderData={columnHeaderData}
        />
      </div>
    </div>  
  )
}

export default Invoices